export default {
  JoinWaitlist: 1,
  Reserve: 2,
  Signup: 3
};
